import React, { useEffect, useState } from 'react';
import './UrgentNeedCardV2.scss';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { sendEvents, urgentDonationData } from '../../../redux/actions/Home';
import DefaultImg from '../../public/images/default-campaign-picture.jpg';
import dayjs from 'dayjs';
import { domSanitizer, getCurrencySymbol, handleKettoLinks, handleRupee } from '../../../services/helperFunctions';

const UrgentNeedCardV2 = () => {

	const [urgentFundraiser, setUrgentFundraiser] = useState();

	useEffect(() => {
		getUrgentData();
	}, []);

	const getUrgentData = () => {
		urgentDonationData().then(
			(res) => {
				const fundraiser = res?.data?.data[0];
				if (!fundraiser) return;
				fundraiser.progress = (fundraiser?.raised?.raised / fundraiser?.amount_requested) * 100;
				const days_left = dayjs(fundraiser?.end_date).diff(new Date(), 'day') + 1;
				if (days_left > 1) {
					fundraiser.days_left = `<strong>${days_left}</strong> Day${days_left > 1 ? 's' : ''} Left`;
				} else {
					fundraiser.days_left = 'Fundraiser Ended';
				}
				if (!fundraiser?.latestorder) {
					fundraiser.lastDonation = '';
				} else {
					let lastDonation = dayjs(new Date()).diff(fundraiser?.latestorder?.creation_date, 'minute');
					fundraiser.lastDonation = lastDonation + ' minute';
					if (lastDonation > 60 * 24) {
						lastDonation = dayjs(new Date()).diff(fundraiser?.latestorder?.creation_date, 'day');
						fundraiser.lastDonation = lastDonation + ' day';
					} else if (lastDonation > 60) {
						lastDonation = dayjs(new Date()).diff(fundraiser?.latestorder?.creation_date, 'hour');
						fundraiser.lastDonation = lastDonation + ' hour';
					}
					fundraiser.lastDonation += lastDonation > 1 ? 's' : '';
				}
				setUrgentFundraiser(fundraiser);
			},
		);
	};

	const handleDonateNow = () => {
		sendEvents('otd_upsell_click', 'sip_returning');
		window.open(
			handleKettoLinks(
				`stories/${urgentFundraiser?.custom_tag}?donate=true`,
			),
		);
	};

	return (
		<>
			{urgentFundraiser && <div className="urgent-need-card-v2">
				{/* Urgent Need Tag */}
				<div className="urgent-tag">
					<span><ErrorOutlineIcon style={{ color: '#F2F2F2', fontSize: '12px' }} /></span>
					<span className="urgent-text">URGENT NEEDS</span>
					<div className="urgent-tag2"></div>
				</div>
				{/* Content */}
				<div className="fundraiser-image-container">
					{/* Image */}
					<img
						className="fundraiser-image"
						src={urgentFundraiser?.theater?.cdn_path || urgentFundraiser?.story_widget?.cdn_path || urgentFundraiser?.widget?.cdn_path || DefaultImg}
						alt="default"
						loading="lazy"
						onError={(e) => { e.target.src = DefaultImg; }} />
					{/* Fundraiser Info */}
					<div className="fundraiser-info">
						{/* Title */}
						<p className="fundraiser-title">{urgentFundraiser?.title}</p>

						{/* Beneficiary */}
						<div className="beneficiary">
							<img
								className="beneficiary-image"
								src={urgentFundraiser?.media_beneficiary?.cdn_path || DefaultImg}
								alt="default"
								loading="lazy"
								onError={(e) => { e.target.src = DefaultImg; }} />
							<span className="beneficiary-text">by {urgentFundraiser?.beneficiaryname?.info_1}</span>
						</div>

						{/* Amount Raised */}
						<div className="amount-raised">
							<span className="amount">{getCurrencySymbol("INR")}{handleRupee(urgentFundraiser?.raised?.raised)}</span>
							<span className="raised-text"> raised</span>
						</div>

						{/* Progress Bar */}
						<div className="progress-bar">
							<div className="prog" style={{ width: urgentFundraiser?.progress + '%' }}></div>
						</div>

						{/* Last Donation */}
						{urgentFundraiser?.lastDonation && <div className="last-donation">
							Last donation {urgentFundraiser?.lastDonation}
						</div>}

						{/* Days Left and Supporters */}
						<div className="stats">
							<div className="days-left">
								<AccessTimeIcon
									sx={{
										color: '#444444', width: '20px', height: '20px',
									}} />
								<span dangerouslySetInnerHTML={{ __html: domSanitizer(urgentFundraiser?.days_left) }}></span>
							</div>
							<div className="supporters">
								<FavoriteIcon
									sx={{
										color: '#EA4335', width: '20px', height: '20px',
									}} />
								<span><strong>{urgentFundraiser?.raised?.backers}</strong> Supporters</span>
							</div>
						</div>
					</div>
				</div>

				{/* Donate Button */}
				<button className="urgent-donate-btn" onClick={handleDonateNow}>
					Donate Now
				</button>
			</div>}
		</>
	);
};

export default UrgentNeedCardV2;